import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const moduleFiles: any = require.context('./modules', true, /index\.ts$/)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const modules: any = moduleFiles.keys().reduce((modules: any, modulePath: string) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = moduleFiles(modulePath)
  const name = moduleName.split('/')[0]
  modules[name] = value.default
  return modules
}, {})
export default new Vuex.Store({
  modules
})
